// Background
export const bgGray = '#F5F6FA'
export const gradientOrange = 'linear-gradient(243deg, #fdf095, #fbbf66, #fbbf66)'
export const bgSoftGray = '#EAEFF5'
export const bgDocDetail = '#FAFAFC'
export const bgStepUnStart = '#ECECEC'
export const bgStepIconInprogress = 'linear-gradient(to bottom, #ffaa85, #fbbf66)'
export const mainColorWithAlpha = 'rgba(251, 191, 102, 0.3)'

// Header
export const headerHeight = '58px'

// Side Menu
export const menuWidth = (collapsed) => collapsed ? '60px' : '150px'
export const menuMinHeight = (collapsed) => collapsed ? '45px' : '80px'

// Theme Colors
export const ezMainColor = '#FBBF66', orange = '#FBBF66'
export const ezBackColor = '#505050'
export const ezGrayColor = bgGray
export const ezRedColor = '#FE6F5F'
export const ezGreenColor = '#32da8b'
export const ezOrange = '#FE9E5F'
export const ezBlue = '#5280ff'
export const ezYellow = '#FCE300'

// Border
export const borderGray     = '#CCCCCC'
export const borderDashGray = 'rgba(217, 217, 217, 0.5)'
export const borderBlueGray = '#EAEFF5'
export const borderStepUnStart = '#DBDBDB'
export const borderStepInprogress = ezMainColor
export const borderStepCompleted = '#2BCB80'
export const borderFile = '#D9D9D9'
export const borderRadius = '5px'

// Status Tag
export const tagDraft               = 'linear-gradient(255deg, #808080, #A8A8A8)'
export const tagNew                 = 'linear-gradient(255deg, #5280ff, #0057ff)'
export const tagInProgress          = 'linear-gradient(213deg, #fc6180, #fa548c)'
export const tagRevise              = 'linear-gradient(255deg, #FF883F, #FE9E5F)'
export const tagCompleted           = 'linear-gradient(252deg, #32da8b, #28c47b)'
export const tagCanceled            = 'linear-gradient(255deg, #ff523f, #fe6f5f)'
export const tagReject              = 'linear-gradient(255deg, #ff1900, #ff4833)'
export const tagApproved            = 'linear-gradient(255deg, #9356fc, #674fff)'
export const tagWaitToAcknowledge   = 'linear-gradient(255deg, #5280ff, #0057ff)'
export const tagAcknowledge         = 'linear-gradient(252deg, #32da8b, #28c47b)'
export const tagExcepted            = 'linear-gradient(255deg, #ff523f, #fe6f5f)'

export const tagColors = [ 
  tagDraft, // 0
  tagNew, // 1
  tagInProgress, // 2 
  tagRevise, // 3
  tagCompleted, // 4
  tagReject, // 5
  tagCanceled, // 6
  tagApproved, // 7
  tagCanceled, // 8
  tagCanceled, // 9
  tagInProgress, // 10
  tagDraft, // 11
  '', // 12
  tagNew, // 13
  '', // 14
  tagWaitToAcknowledge, // 15
  tagAcknowledge,  // 16
  tagExcepted, // 17
  tagDraft, // 18 BG Not Start
  tagRevise, // 19 BG Changed
  tagCanceled, // 20 BG Expired,
  tagCompleted, // 21 BG Returned
  tagInProgress, // 22 Approver Review
  tagInProgress, // 23 Account Officer Review
  tagInProgress, // 24 Account Manager Review
  tagInProgress, // 25 Finance Review
  tagInProgress, // 26 Finance Processing
  tagRevise, // 27 Wait for Original Document
  tagNew, // 28 Accepted
]
export const textStatusColors = ['#808080', '#5280ff', '#fc6180', '#FF883F', '#32da8b', '#ff1900', '#ff523f', '#9356fc', '#ff523f', '#ff523f', '#fc6180', '#808080', '', '', '', '#5280ff', '#32da8b', '#ff523f']

//Text Color
export const textBlack     = ezBackColor
export const textSoftBlack = '#707070'
export const textGray      = '#A1A1A1'
export const textRed       = ezRedColor

//Button Color
export const btnGray = '#647d91'
export const btnRed  = 'linear-gradient(247deg, #fc6180, #fa548c)'
export const btnGreen = 'linear-gradient(245deg, #32da8b, #28c47b)'
export const btnBlue = 'linear-gradient(255deg, #5280ff, #0057ff)'

//Box Shadow
export const boxShadow = '0px 1px 2px 1px rgba(0, 0, 0, 0.16)'
export const boxShadowHover = '0 4px 4px 0 rgba(0, 0, 0, 0.16)'